/**
 * Legacy browser fallback for images with data-legacy-src.
 * Swaps src to the JPG fallback when <picture> or srcset are not supported.
 */
import { onReady } from './on-ready.js';

function initLegacyImages() {
    if ('HTMLPictureElement' in window && 'srcset' in document.createElement('img')) {
        return;
    }

    document.querySelectorAll('img[data-legacy-src]').forEach((img) => {
        const legacySrc = img.getAttribute('data-legacy-src');
        if (legacySrc) {
            img.src = legacySrc;
        }
    });
}

onReady(initLegacyImages);
